import { useContext } from "react";
import { ActiveLangContext } from "../components/context/active-lang-context";
import { LANGUAGE_EN } from "../constants";
export var useActiveLang = function useActiveLang() {
  return useContext(ActiveLangContext) || LANGUAGE_EN;
};